import React, { useState, useEffect } from "react";

import CopiableURL from "../../CopiableURL";
import {
  BADGES,
  getUrlVars,
  removeAllParamsURL,
} from "../../../services/helpers";
import { getClicks } from "../../../services/Bitly";

const Bitlink = (props) => {
  const [clicks, updateClicks] = useState({ qnt: null, isLoaded: false });
  const tags = getUrlVars(props.link.long_url);

  useEffect(() => {
    if (!clicks.isLoaded) {
      getClicks(props, props.link.id).then((data) => {
        let reducer = (accumulator, currentValue) =>
          accumulator + parseInt(currentValue.clicks);
        let total_clicks = data.data.link_clicks.reduce(reducer, 0);
        updateClicks({ ...clicks, qnt: total_clicks, isLoaded: true });
      });
    }
  }, [props, clicks]);

  return (
    <div key={props.link.created_at}>
      <div className="click-box">
        {" "}
        <p className="clicks-quant">
          {clicks.qnt !== null ? clicks.qnt : 0}
        </p>{" "}
        Cliques
      </div>
      <p>
        <span className="link-title">{props.link.title}</span>
        <br />
        <CopiableURL
          url={removeAllParamsURL(props.link.long_url)}
          text={removeAllParamsURL(props.link.long_url)}
        />
        <br />
        <CopiableURL url={props.link.link} text={props.link.link} />
        <br />
        {tags &&
          tags.map((tag, index) => {
            return (
              <span key={index} className={`tags badge ${BADGES[index]}`}>
                {tag}
              </span>
            );
          })}
      </p>
      <hr />
    </div>
  );
};
export default Bitlink;
